var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewListingsTrenddownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0012 7.16652C13.0012 7.23185 12.9878 7.29659 12.9625 7.35793C12.9118 7.47993 12.8145 7.57726 12.6925 7.6286C12.6312 7.65393 12.5665 7.66717 12.5012 7.66717H9.73183C9.45583 7.66717 9.23183 7.44317 9.23183 7.16717C9.23183 6.89117 9.45583 6.66717 9.73183 6.66717H11.2938L7.28516 2.65854C7.21983 2.59321 7.1145 2.59321 7.04917 2.65854L5.32516 4.3825C4.86983 4.83784 4.1305 4.83784 3.67517 4.3825L0.1465 0.853857C-0.0488333 0.658523 -0.0488333 0.341833 0.1465 0.1465C0.341833 -0.0488333 0.658503 -0.0488333 0.853836 0.1465L4.3825 3.67515C4.44784 3.74048 4.55316 3.74048 4.61849 3.67515L6.34249 1.95119C6.79783 1.49585 7.53717 1.49585 7.9925 1.95119L12.0012 5.95981V4.3978C12.0012 4.1218 12.2252 3.8978 12.5012 3.8978C12.7772 3.8978 13.0012 4.1218 13.0012 4.3978V7.16652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewListingsTrenddownIcon);
export default __webpack_public_path__ + "static/media/new-listings-trenddown-icon.a51fc93eb84c43fabadc1a5579a6bc20.svg";
export { ForwardRef as ReactComponent };